import { Component, ChangeDetectionStrategy, Output, EventEmitter, signal } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucidePencilRuler, lucideRotateCcw, lucideX } from '@ng-icons/lucide';
import {
  HlmAlertDialogComponent,
  HlmAlertDialogContentComponent,
  HlmAlertDialogHeaderComponent,
  HlmAlertDialogTitleDirective,
  HlmAlertDialogDescriptionDirective,
} from '@spartan-ng/helm/alert-dialog';
import { BrnAlertDialogContentDirective } from '@spartan-ng/brain/alert-dialog';

/**
 * Explains why planning/placement failed with no roof areas to work with, and
 * offers the two real fixes instead of letting the caller blindly retry the
 * same stage into the same error: draw the roof areas manually, or re-run
 * detection (which is what should have produced them).
 */
@Component({
  selector: 'app-missing-roof-data-dialog',
  standalone: true,
  imports: [
    NgIconComponent,
    HlmAlertDialogComponent,
    HlmAlertDialogContentComponent,
    HlmAlertDialogHeaderComponent,
    HlmAlertDialogTitleDirective,
    HlmAlertDialogDescriptionDirective,
    BrnAlertDialogContentDirective,
  ],
  providers: [provideIcons({ lucidePencilRuler, lucideRotateCcw, lucideX })],
  templateUrl: './missing-roof-data-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissingRoofDataDialog {
  @Output() drawManually = new EventEmitter<void>();
  @Output() rerunDetection = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  state = signal<'open' | 'closed'>('closed');

  open(): void {
    this.state.set('open');
  }

  close(): void {
    this.state.set('closed');
    this.cancelled.emit();
  }

  chooseDraw(): void {
    this.state.set('closed');
    this.drawManually.emit();
  }

  chooseRerun(): void {
    this.state.set('closed');
    this.rerunDetection.emit();
  }
}
